import * as d3 from 'd3';

import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { BulletChart, BulletChartOptions, Kpi } from '../../../charting/index';

export interface IbulletChartDirective extends ng.IDirective {
}

export interface IbulletChartDirectiveScope extends ng.IScope {
    options: BulletChartOptions;
    id: string;
    kpi: Kpi;
    kpiList: Kpi[];
}

export class BulletChartDirective extends ChartDirectiveBase implements IbulletChartDirective {
    static directiveId = 'wtBulletChart';

    constructor() {
        super();
        this.scope = {
            options: '=',
            id: '@',
            kpi: '=',
            kpiList: '='
        };
        this.template = '<div class="bullet-chart"><svg></svg></div>';
    }

    link(scope: IbulletChartDirectiveScope, element, attrs, controller) {
        if (!attrs.id) {
            console.error('Using a chart directive requires that an id is set to the directive.');
        } else {
            const containerName = attrs.id;
            element.attr('id', containerName);
            const manager = new SvgManager(containerName, new Margins(0, 0, 10, 0));

            const chart = new BulletChart(d3, manager);
            scope.$watch(() => scope.kpi, () => {
                chart.update(scope.kpi);
                if (scope.kpi.subscriptions) {
                    scope.kpi.subscriptions.forEach(s => {
                        chart.on(s.name, s.callback);
                    });
                }
            }, true);
            scope.$watch(() => scope.options, () => {
                chart.options(scope.options);
            }, true);
            scope.$watch(() => scope.kpiList, () => {
                chart.list(scope.kpiList);
            }, true);
        }
    }

}